// src/components/CategoryManager.jsx
import React from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import axios from 'axios'
import { getAccessToken } from '../services/AuthService'

const CategoryManager = ({ onClose, categories, setCategories, reload }) => {
  const token = getAccessToken()
  const headers = { Authorization: `Bearer ${token}` }

  const handleDelete = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/category_detail/${id}/`
    await axios.delete(url, { headers, timeout: 5000 })
    setCategories((prev) => prev.filter((c) => c.id !== id))
  }

  const handleCreate = async (values, { setSubmitting, resetForm }) => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL}/api/category_list/`
      const formData = new FormData()
      formData.append('title', values.title)
      formData.append('description', values.description)
      await axios.post(url, formData, { headers, timeout: 5000 })
      await reload()
      resetForm()
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="modal show" style={{ display: 'block' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content shadow">
          <div className="modal-header">
            <h5 className="modal-title">Gestionar categorías</h5>
            <button type="button" className="close" aria-label="Close" onClick={onClose}>
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            <h6 className="mb-2">Añadir nueva</h6>
            <Formik
              initialValues={{ title: '', description: '' }}
              onSubmit={handleCreate}
            >
              {({ isSubmitting }) => (
                <Form className="mb-3">
                  <div className="row g-2">
                    <div className="col-md-4">
                      <Field name="title" className="form-control" placeholder="Título" required />
                      <ErrorMessage name="title" component="div" className="text-danger" />
                    </div>
                    <div className="col-md-6">
                      <Field name="description" className="form-control" placeholder="Descripción" required />
                      <ErrorMessage name="description" component="div" className="text-danger" />
                    </div>
                    <div className="col-md-2">
                      <button type="submit" disabled={isSubmitting} className="btn btn-primary w-100">
                        Crear
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>

            <hr />

            <h6 className="mb-2">Lista</h6>
            <ul className="list-group">
              {categories.map((c) => (
                <li
                  key={c.id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div>
                    <strong>{c.title}</strong>
                    {c.description ? <span className="text-muted"> — {c.description}</span> : null}
                  </div>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(c.id)}>
                    Eliminar
                  </button>
                </li>
              ))}
              {categories.length === 0 && (
                <li className="list-group-item text-muted">No hay categorías todavía.</li>
              )}
            </ul>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CategoryManager
